// extracted by mini-css-extract-plugin
export default {"itemsRoot":"field_category-module___itemsRoot___e1829ee8","root":"field_category-module___root___d350e123"};